export default {
  computed: {
    isLoginRelated() {
      return this.$route.path === "/login";
    },
  },
};
